import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { SelectItem, OverlayPanel } from 'primeng/primeng';

import { EntityRelationsService } from 'app/entities/relations/entity-relations.service';
import { EntityIdDetails, EntityType } from 'app/shared/models/entity-id-details.model';
import { EntityRelation } from 'app/shared/models/entity-relation.model';
import { ConstantsService } from 'app/services/constants-service';
import { Right, TransactionRule } from 'app/entities/transaction-profile/right.model';
import { FormErrors, isValidMailFormat } from 'app/shared/validators/generic-validators';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { Obligation } from 'app/shared/models/obligation.model';
import { User } from 'app/shared/models/user.model';
import { GenericSearchDetails } from 'app/shared/models/generic-search-details.model';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { BankAccount } from 'app/shared/models/bank-account.model';


@Component({
  selector: 'add-right',
  templateUrl: './add-right.component.html',
  styleUrls: ['./add-right.component.css']
})
/**
 * Component to add a new right.
 */
export class AddRightComponent implements OnInit {

  entityIdDetails: EntityIdDetails;
  action: string;
  selectedRight: Right;
  rightForm: FormGroup;
  isLoading = false;
  selectedIndex = 0;
  agreementId: number;
  options = {};
  showClientPage = false;
  transactionRules: TransactionRule[];
  rightId: number;
  actionType: string;
  bankAccounts: BankAccount[];
  countryTypes: ApplicationValue[];
  cashFlows: ApplicationValue[];
  transactionFrequencyPeriods: ApplicationValue[];
  roles: ApplicationValue[];
  counterParties: any[];
  selectedTranactionRule: TransactionRule;
  selectedEntity: GenericSearchDetails;
  searchURI = ConstantsService.HEADER_SEARCH;
  searchPlaceholder = MessageService.HEADER_SEARCH_PLACEHOLDER;
  amountRangeCheckbox: boolean;
  maxAmountCheckbox: boolean;
  frequencyCheckbox: boolean;
  originCountryCheckbox: boolean;
  counterPartyCheckbox: boolean;

  formErrors = {
    'name': '',
  };

  validationMessages = {
    'name': {
      'required': 'Required field value.',
    }
  };

  constructor(
    public dialogRef: MdDialogRef<any>,
    private fb: FormBuilder,
    private entityTransactionProfileService: EntityTransactionProfileService,
    private trackingService: TrackingService,
    private entityRelationsService: EntityRelationsService,
    private snackBarService: SnackBarService,
    private warmUpService: WarmUpService,
  ) { }

  ngOnInit() {
    this.rightId = this.selectedRight && this.selectedRight.id;
    this.buildForm();
  }

  buildForm() {
    this.loadData();
    this.rightForm = this.fb.group({
      name: ['', Validators.required],
      counterParty: [''],
      counterPartyId: [''],
      clientName: [''],
      profileName: [''],
      txnDescription: [''],
      accountNo: [''],
      cashFlow: [''],
      amountFrom: [''],
      searchValue: [''],
      amountTo: [''],
      maxAmount: [''],
      maxAmountPeriod: [''],
      frequency: [''],
      frequencyPeriod: [''],
      originCountry: [''],
      counterPartyName: [''],
      role: [''],
      counterPartyAccountNumber: [''],
    });
    this.rightForm.valueChanges.subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
    this.updateRigthForm();
  }

  updateRigthForm(): void {
    if (this.selectedRight) {
      this.rightForm.patchValue({
        name: this.selectedRight.right,
        counterPartyName: this.selectedRight.counterPartyName,
        counterPartyId: this.selectedRight.counterPartyId
      });
    }
  }

  updateRightFormWithTransactionRule(): void {
    if (this.selectedTranactionRule) {
      this.rightForm.patchValue({
        profileName: this.selectedTranactionRule.name,
        counterPartyName: this.selectedTranactionRule.counterPartyId,
        accountNo: this.selectedTranactionRule.accountNo,
        counterPartyAccountNumber: this.selectedTranactionRule.counterPartyAccountNumber,
        txnDescription: this.selectedTranactionRule.txnDescription,
        amountFrom: this.selectedTranactionRule.amountFrom,
        amountTo: this.selectedTranactionRule.amountTo,
        maxAmount: this.selectedTranactionRule.maxAmount,
        maxAmountPeriod: this.selectedTranactionRule.maxAmountPeriod,
        frequency: this.selectedTranactionRule.frequency,
        frequencyPeriod: this.selectedTranactionRule.frequencyPeriod,
        originCountry: this.selectedTranactionRule.originCountry,
        cashFlow: this.selectedTranactionRule.cashFlow,
      });
      this.updateRigthForm();
      if (this.selectedTranactionRule.amountFrom + this.selectedTranactionRule.amountTo) {
        this.enableOptionStatus('amountRange');
        this.amountRangeCheckbox = true;
      }
      if (this.selectedTranactionRule.maxAmount) {
        this.enableOptionStatus('maxAmount');
        this.maxAmountCheckbox = true;
      }
      if (this.selectedTranactionRule.frequency) {
        this.enableOptionStatus('frequency');
        this.frequencyCheckbox = true;
      }

      if (this.selectedTranactionRule.originCountry) {
        this.enableOptionStatus('originCountry');
        this.originCountryCheckbox = true;
      }
      console.log(this.selectedTranactionRule);
      if (this.selectedTranactionRule.counterPartyId) {
        this.enableOptionStatus('counterParty');
        this.counterPartyCheckbox = true;
      }
    }
  }

  loadData() {
    this.loadTransactionRules();
    this.entityTransactionProfileService.getBankAccountsForEntity(
      this.entityIdDetails.entityId).subscribe(response => {
        this.bankAccounts = response;
      });

    this.loadTransactionCounterParty();
    const setCountryTypes = (values) => {
      this.countryTypes = values;
    };
    const setCashFlows = (values) => {
      this.cashFlows = values;
    };
    const setTransactionFrequencyPeriod = (values) => {
      this.transactionFrequencyPeriods = values;
    };
    const setRoles = (values) => {
      this.roles = values;
    };

    this.warmUpService.getApplicationValueList(
      ApplicationTypeConstants.COUNTRY_TYPE, setCountryTypes);
    this.warmUpService.getApplicationValueList(
      ApplicationTypeConstants.CASH_FLOW, setCashFlows);
    this.warmUpService.getApplicationValueList(
      ApplicationTypeConstants.RELATION_ROLE_TYPES, setRoles);
    this.warmUpService.getApplicationValueList(
      ApplicationTypeConstants.TRANSACTION_FREQUENCY_PERIOD,
      setTransactionFrequencyPeriod);
  }

  loadTransactionRules() {
    this.entityTransactionProfileService.getTransactionRules(
      this.entityIdDetails.clientId, this.rightId || 0, true).subscribe(response => {
        this.transactionRules = response;
      });
  }

  loadTransactionCounterParty() {
    this.entityTransactionProfileService.getTransactionCounterParty(
      this.entityIdDetails.entityId, 10).subscribe(response => {
        if (response.flagResult) {
          this.counterParties = response.arrResult;
        }
      });
  }

  onValueChanged(data?: any) {
    if (!this.rightForm) {
      return;
    }
    const form = this.rightForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.touched && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

  onEntitySelection(searchDetails: GenericSearchDetails) {
    this.selectedEntity = searchDetails;
    this.rightForm.controls['clientName'].setValue(this.selectedEntity.clientName);
    this.rightForm.controls['clientName'].markAsTouched();
  }

  selectedIndexChange(tabIndex: number) {
    this.selectedIndex = tabIndex;

  }

  getCounterPartyId(counterPartyName: number) {
    const relation = this.counterParties['relations'].find(
      obj => obj.name === counterPartyName);
    return relation && relation.entityId || '';
  }

  getApplicationValueName(valueList, applicationValueId) {
    const applicationValue = valueList.find(
      obj => obj.id === applicationValueId);
    return applicationValue && applicationValue.name || '';
  }

  enableOptionStatus(optionName) {
    if (this.options.hasOwnProperty(optionName) && this.options[optionName]) {
      this.options[optionName] = false;
    } else {
      this.options[optionName] = true;
    }
  }

  createNewCounterParty() {
    const relationVO = new EntityRelation();
    relationVO.subjectId = this.entityIdDetails.entityId;
    relationVO.entityId = this.selectedEntity.entityId;
    relationVO.clientId = this.selectedEntity.clientId;
    relationVO.detailId = this.selectedEntity.id;
    relationVO.role = this.rightForm.controls['role']['value'];
    relationVO.entityType = EntityType[this.entityIdDetails.entityType.toString()];
    this.entityRelationsService.addRelation(this.entityIdDetails.entityId, relationVO)
      .subscribe(response => {
        this.loadTransactionCounterParty();
        this.callSnackBarService(response, MessageService.COUNTER_SAVE_SUCCESS, '');
      }, err => {
        this.callSnackBarService(err, '', MessageService.COUNTER_SAVE_FAILUR);
      });
  }

  showCreateClientContent() {
    this.showClientPage = true;
  }

  editTransactionRule(rule: TransactionRule) {
    this.selectedTranactionRule = rule;
    this.selectedIndex = 1;
    this.updateRightFormWithTransactionRule();
  }

  deleteTransactionRule(transactionRule: TransactionRule) {
    this.isLoading = true;
    this.entityTransactionProfileService.removeTransactionRule(transactionRule.id)
      .subscribe(response => {
        this.loadTransactionRules();
        this.callSnackBarService(response, MessageService.TRANSACTION_DELETE_SUCCESS, '');
      }, err => {
        this.callSnackBarService(err, '', MessageService.TRANSACTION_DELETE_FAILURE);
      });
  }

  addRigth(value) {
    this.isLoading = true;
    const right = new Right();
    right.id = this.selectedRight && this.selectedRight.id || 0;
    right.right = value.name;
    right.counterPartyId = this.normalizeCounterPartyId(value.counterPartyId);
    right.counterPartyName = value.counterPartyName || null;
    right.agreementId = this.agreementId;
    right.transactionRule = this.selectedTranactionRule;

    this.entityTransactionProfileService.saveRight(right).subscribe(response => {
      if (response.flagResult) {
        right.id = response.arrResult;
        this.dialogRef.close(right);
      }
      this.callSnackBarService(response, MessageService.RIGHT_SAVE_SUCCESS, '');
    }, err => {
      this.callSnackBarService(err, '', MessageService.RIGHT_SAVE_FAILURE);
    });
  }

  addTransactionRule(value) {
    this.isLoading = true;
    const transactionRule = new TransactionRule();
    transactionRule.id = 0;
    transactionRule.accountNo = value.accountNo;
    transactionRule.name = value.profileName;
    transactionRule.txnDescription = value.txnDescription;
    if (this.options.hasOwnProperty('amountRange')) {
      transactionRule.amountFrom = value.amountFrom;
      transactionRule.amountTo = value.amountTo;
    }

    if (this.options.hasOwnProperty('maxAmount')) {
      transactionRule.maxAmount = value.maxAmount;
      transactionRule.maxAmountPeriod = value.maxAmountPeriod;
      transactionRule.maxAmountPeriodName = this.getApplicationValueName(
        this.transactionFrequencyPeriods, value.maxAmountPeriod);
    }

    if (this.options.hasOwnProperty('frequency')) {
      transactionRule.frequency = value.frequency;
      transactionRule.frequencyPeriod = value.frequencyPeriod;
      transactionRule.frequencyPeriodName = this.getApplicationValueName(
        this.transactionFrequencyPeriods, value.frequencyPeriod);
    }

    if (this.options.hasOwnProperty('originCountry')) {
      transactionRule.originCountry = value.originCountry;
      transactionRule.originCountryName = this.getApplicationValueName(
        this.countryTypes, value.originCountry);
    }

    if (this.options.hasOwnProperty('counterParty')) {
      transactionRule.counterPartyId = this.normalizeCounterPartyId(value.counterPartyId);
      transactionRule.counterPartyName = value.counterPartyName || null;
      transactionRule.counterPartyAccountNumber = value.counterPartyAccountNumber || null;
    }

    transactionRule.cashFlow = value.cashFlow;
    transactionRule.cashFlowName = this.getApplicationValueName(this.cashFlows, value.cashFlow);

    this.entityTransactionProfileService.saveTransactionRuleForRight(
      this.entityIdDetails.clientId, 0, transactionRule).subscribe(response => {
        if (response.flagResult) {
          this.selectedIndex = 0;
          this.loadTransactionRules();
        }
        this.callSnackBarService(response, MessageService.RIGHT_SAVE_SUCCESS, '');
      }, err => {
        this.callSnackBarService(err, '', MessageService.RIGHT_SAVE_FAILURE);
      });
  }

  onSubmit({ value, valid }) {
    if (!this.selectedIndex) {
      this.addRigth(value);
    } else {
      this.addTransactionRule(value);
    }
  }

  callSnackBarService(response: any, success: string, failur: string) {
    this.isLoading = false;
    this.snackBarService.showStatus(response, success, failur);
  }

  transactionRuleChange(selectedTranaction: TransactionRule) {
    this.selectedTranactionRule = selectedTranaction;
  }

  closeDialog(): void {
    this.rightForm.reset();
    this.dialogRef.close();
  }

  onEntityRelationSelectionEvent(selectedRelation: EntityRelation, overlaypanel: OverlayPanel) {
    this.rightForm.patchValue({
      counterPartyName: selectedRelation.name,
      counterPartyId: selectedRelation.entityId
    });
    overlaypanel.hide();
  }
  showRelation(event, overlaypanel: OverlayPanel) {
    overlaypanel.toggle(event);
  }

  /**
   * Normalizes counterPartyId: converts empty strings, null, undefined, or 0 to null.
   * This ensures the backend receives null instead of empty string, preventing NullPointerException.
   */
  private normalizeCounterPartyId(counterPartyId: any): number | null {
    if (counterPartyId === null || counterPartyId === undefined || counterPartyId === '' || counterPartyId === 0) {
      return null;
    }
    // Convert string to number if it's a valid number string
    if (typeof counterPartyId === 'string' && counterPartyId.trim() !== '') {
      const num = Number(counterPartyId);
      return isNaN(num) || num === 0 ? null : num;
    }
    // Return as number if it's already a valid number
    const num = Number(counterPartyId);
    return isNaN(num) || num === 0 ? null : num;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/rights/addright/add-right.component.ts